// eslint-disable-next-line no-restricted-syntax
export const SENTRY_RELEASE = import.meta.env.SENTRY_RELEASE as string | undefined
